import { Helmet, HelmetProvider } from "react-helmet-async"
import { Button, Flex, Image, Link, Text } from "@chakra-ui/react"
import { Outlet } from "@tanstack/react-router"

import downtimeGraphic from "#/assets/downtime-graphic.png"
import ogImage from "#/assets/mezo-landing-ogimage.png"
import mezoLogo from "#/assets/mezo-logo-inline.svg"
import {
  SanityCmsDataType,
  useBeforeUnload,
  useBorrowData,
  useDAppRoute,
  useMarketData,
  useSanityCmsData,
  useSegmentPageView,
  useSentry,
  useWallet,
} from "#/shared/hooks"
import { AppContainer } from "#/ui/AppContainer"
import ErrorWrapper from "#/ui-old/ErrorWrapper"
import MezoModal from "#/ui-old/Modal"

type DownpageData = {
  enableDownpage?: boolean
  downpageTitle?: string
  downpageText?: string
  downpageButtonText?: string
  downpageButtonLink?: string
}

export default function App() {
  const isDAppRoute = useDAppRoute()

  useSentry()
  useSegmentPageView()
  useWallet()
  useBorrowData()
  useBeforeUnload()
  useMarketData()

  const { data: downpageData } = useSanityCmsData<DownpageData>(
    SanityCmsDataType.Downtime,
  )

  const isDown = downpageData?.enableDownpage === true

  if (!isDAppRoute) {
    return <Outlet />
  }

  if (isDown) {
    return (
      <Flex
        direction="column"
        justify="center"
        align="center"
        minH="100vh"
        bg="white"
        color="black"
        textAlign="center"
        p={10}
      >
        <Image
          src={downtimeGraphic}
          alt="Downtime graphic"
          maxW={{ base: "100%", md: "400px" }}
        />
        <Text mt="40px" fontSize="4xl" fontWeight="bold" mb={4}>
          {downpageData?.downpageTitle || "We’ll be right back."}
        </Text>
        <Text fontSize="22px" mb={4}>
          {downpageData?.downpageText ||
            "For updates and status reports, join us on Discord."}
        </Text>
        {/* {errorData?.errorButtonLink && errorData?.errorButtonText && ( */}
        <Link
          href={downpageData?.downpageButtonLink || "https://discord.mezo.org/"}
          isExternal
        >
          <Button
            m="20px"
            p="20px 80px"
            fontSize="18px"
            borderRadius="20px"
            _hover={{ bg: "primary.red.100" }}
            bg="primary.black.100"
            color="white"
          >
            {downpageData?.downpageButtonText || "Open Discord"}
          </Button>
        </Link>
        {/* )} */}
        <Image src={mezoLogo} alt="Mezo Logo" mt="100px" />
      </Flex>
    )
  }

  return (
    <>
      <HelmetProvider>
        <Helmet>
          <meta property="og:image" content={`https://mezo.org${ogImage}`} />
        </Helmet>
      </HelmetProvider>
      <ErrorWrapper>
        <AppContainer />
        <MezoModal />
      </ErrorWrapper>
    </>
  )
}
